import { render, staticRenderFns } from "./my-guessing-gold.vue?vue&type=template&id=dfd91c02&scoped=true&"
import script from "./my-guessing-gold.vue?vue&type=script&lang=js&"
export * from "./my-guessing-gold.vue?vue&type=script&lang=js&"
import style0 from "./my-guessing-gold.vue?vue&type=style&index=0&id=dfd91c02&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfd91c02",
  null
  
)

export default component.exports